import app from 'flarum/common/app';
import Widgets from 'ext:fof/forum-widgets-core/common/extend/Widgets';
import PopularTagsWidget from './components/PopularTagsWidget';
export default function registerWidget() {
  new Widgets().add({
    key: 'popularTags',
    component: PopularTagsWidget,
    isDisabled: false,
    isUnique: true,
    placement: 'end',
    position: 4
  }).extend(app, 'swtorpolska-popular-tags');
}
flarum.reg.add('swtorpolska-popular-tags', 'common/registerWidget', registerWidget);